import "./about.css";
import framer1 from "../../assets/mikke.jpg";
import framer2 from "../../assets/Frame1.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import {
  faGithub,
  faInstagram,
  faLinkedin,
  faMailchimp,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";

const buttonVariants = {
  tap: {
    scale: 0.9,
    rotate: [0, -5, 5, -5, 5, 0],
    transition: {
      duration: 0.5,
    },
  },
};
function About() {
  return (
    <div className="about__container">
      <motion.h2
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 5 }}
      >
        <span>#</span>About-me
      </motion.h2>
      <div className="side__container">
        <div className="about__left__container">
          <div className="about__paragraph">
            <motion.p
              initial={{ opacity: 0, scaleX: 0.9 }}
              whileInView={{ opacity: 1, scaleX: 1 }}
              transition={{ duration: 3, type: "spring" }}
            >
              Hey! I'm mike, if you haven't already gathered that by now. I'm a
              Developer. I specialize in the web Development Although a
              fullstack , i enjoy most backend, primarily Node and ruby on
              rails, but love building with whatever tools are right for the
              job. I currently work as a freelancer remotely. I also toss in my
              ¢2 with the design systems teams from time to time. Outside of
              coding, I love gaming.I'm passively looking for new positions
              where I can merge my love for code with my love for the canvas.{" "}
              <br />
              Other than being a web developer i am also learning mobile app
              development in flutter js and React native. If you think you've
              got an opening that I might like, let's connect 🔗
            </motion.p>
          </div>
          <div className="about-social-containers">
            <div className="readmore__button button">
              <p>More</p>
              <FontAwesomeIcon icon={faArrowRight} size="1x" color="#black" />
            </div>
            <div className="socials-about">
              <motion.div
                className="social-media"
                variants={buttonVariants}
                whileHover="tap"
              >
                <a
                  href="https://www.instagram.com/mikey_mbugua/"
                  target="_blank"
                >
                  <FontAwesomeIcon
                    icon={faInstagram}
                    color="#9ab5e7"
                    size="2xl"
                  />
                </a>
              </motion.div>
              <motion.div
                className="social-media"
                variants={buttonVariants}
                whileHover="tap"
              >
                <a href="https://twitter.com/MichaelKamiri2" target="_blank">
                  <FontAwesomeIcon
                    icon={faTwitter}
                    color="#9ab5e7"
                    size="2xl"
                  />
                </a>
              </motion.div>
              <motion.div
                className="social-media"
                variants={buttonVariants}
                whileHover="tap"
              >
                <a href="https://www.github.com/mike-mbugua" target="_blank">
                  <FontAwesomeIcon icon={faGithub} color="#9ab5e7" size="2xl" />
                </a>
              </motion.div>
              <motion.div
                className="social-media"
                variants={buttonVariants}
                whileHover="tap"
              >
                <a
                  href="https://www.linkedin.com/in/michael-kamiri-mbugua/"
                  target="_blank"
                >
                  <FontAwesomeIcon
                    icon={faLinkedin}
                    color="#9ab5e7"
                    size="2xl"
                  />
                </a>
              </motion.div>
            </div>
          </div>
        </div>

        <div className="about__right__container">
          <div className="framer1">
            <motion.img
              src={framer1}
              alt=""
              initial={{ rotate: 0, opacity: 0, scaleX: -1 }}
              whileInView={{ opacity: 1, scaleX: 1 }}
              transition={{ duration: 7 }}
            />
          </div>
          <div className="framer2">
            <img src={framer2} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
